/* eslint-disable */
import React, { FC, useState, useContext, useEffect } from 'react';
import queryString from 'query-string';
import { useLocation, useHistory } from 'react-router-dom';

import { LoginContext } from '../context/LoginContext';

import axios from 'axios';
import Label from '../atoms/label/label';
import FloatingInput from '../atoms/floatingInput/floatingInput';
import './password.scss';
// import LogoAndCopyright from '../../../components/organisms/purchase/logoAndCopyright/logoAndCopyright';
import BackArrow from '../atoms/backArrow/backArrow';
import PasswordEye from '../assets/fieldIcons/passwordEye.png';
import PasswordEyeShow from '../assets/fieldIcons/passwordEyeShow.png';
import { Link } from 'react-router-dom';

import loaderData from '../assets/loader.json';

import LoaderLight from '../atoms/loaderLight/loaderLight';

import { getCookie } from '../utils/utils';


const Password = ({
  open,
  onClose,
  signInSuccess,
  signUpSuccess,
  onBack,
}) => {
//   const localization = useContext(LanguageContext);
  const loginContext = useContext(LoginContext);
//   const user = useContext(UserContext);
  const history = useHistory();
  const currentLocation = history.location.pathname;
//   const {
//     password_header_text,
//     password_header_subtext,
//     password_subheader_text,
//     password_label,
//     unableToLogin,
//     generic_api_error_toast_message,
//     hello,
//   } = localization.state.language;
  const [password, setPassword] = useState('');
  const [passwordValid, setPasswordValid] = useState(false);
  const [iOSbtnNormal, setIOSbtnNormal] = useState('');
  const [iOSbtnEnabled, setIOSbtnEnabled] = useState('');
  const [loader, setLoader] = useState(false);

  const [passwordInputClass, setPasswordInputClass] =
    useState('password-input');
  const [showToast, setShowToast] = useState('none');
  const [passwordEyeStateVal, setPasswordEyeStateVal] = useState('password');
  const [showPasswordReset, setShowPasswordReset] = useState(false);
  const [sendingResetLink, setSendingResetLink] = useState(false);
  const [toastMessage, setToastMessage] = useState('');
  const [passwordModalText, setPasswordModalText] = useState(
    'Enter the password to login',
  );

  const { search } = useLocation();
  const queryParamValues = queryString.parse(search);

   const verify2faPassword = async (data) => {
    let returnData;
    await axios.post('/api/auth/2fa/verify-password', data).then((res) => {
      returnData = res;
    });
    return returnData;
  };

  const sendResetPasswordLink = async (data) => {
    let returnData;
    await axios
      .post('/api/auth/2fa/send-reset-password-link', data)
      .then((res) => {
        returnData = res;
      });
    console.log("returnData")

    return returnData;
  };

  const callSendResetPasswordLink = () => {
    // setToastMessage("Link sent! ");
    // setShowToast("block");
    setSendingResetLink(true); // Enable when calling reset api
    // setTimeout(() => {
    //     setShowToast("none");
    // }, 1000);
    let data = {
      '2faId':
        loginContext.state && loginContext.state.accountDetails.mfaInfo &&
        loginContext.state.accountDetails.mfaInfo.mfaId,
      verificationId: loginContext.state.accountDetails.verificationId,
    };

    console.log("resetpassword", data);

    sendResetPasswordLink(data).then(
      (res) => {
        if (
          res.data &&
          res.data.data &&
          res.data.data.status &&
          res.data.data.status.toString().toLowerCase() === 'success'
        ) {
          setToastMessage('Link sent! ');
          setShowToast('block');
          // Disable this on success or failure
          setSendingResetLink(false);
          // Disable this on success
          setShowPasswordReset(false);
          setTimeout(() => {
            setShowToast('none');
          }, 3000);
          // onClose();
        } else {
          let tempErrorMessage = res.data.data.message
            ? res.data.data.message
            : 'Error in sending reset link';
          setSendingResetLink(false);
          // Disable this on success
          setShowPasswordReset(false);
          setToastMessage('Something Wnet wrong');
          setShowToast('block');
          setTimeout(() => {
            setShowToast('none');
          }, 3000);
        }
      },
      (err) => {
        setShowPasswordReset(false);
        setToastMessage('Something went wrong');
        setShowToast('block');
        setTimeout(() => {
          setShowToast('none');
        }, 3000);
        setSendingResetLink(false);
      },
    );
  };

  const passwordChange = (e) => {
    setLoader(false);
    setPasswordInputClass('input-green');

    if (e.target.value) {
      let val = e.target.value.trim();
      if (val.length > 0) setPasswordValid(true);
      else setPasswordValid(false);
      setPassword(val);
      setPasswordInputClass('input-green');
    } else {
      setPassword('');
      // setPasswordInputClass('password-input');
      setPasswordValid(false);
    }
  };

  const reset = () => {
    setPassword('');
    setPasswordValid(false);
    setPasswordInputClass('password-input');
  };

  const onClick = () => {
    let data = {
      password: password,
      mfaId: loginContext.state.accountDetails.mfaInfo.mfaId || '',
      verificationId: loginContext.state.accountDetails.verificationId,
      captchaInfo: {
        gcaptcha: loginContext.state.captchaToken,
        fingerPrint: '',
        storageId: localStorage.getItem('storageId'),
      },
    };

    verify2faPassword(data)
      .then(
        (res) => {
          if (res && res.data) {
            if (
              res &&
              res.data &&
              res.data.data &&
              res.data.data.status &&
              res.data.data.status.toString().toLowerCase() === 'success'
            ) {
            //   await user.dispatch.asyncSetUserDetails();
              let temp_uuid = getCookie('utm_uuid');
              setPasswordInputClass('password-input');
              // loginContext.dispatch.signIn('');
              const newUser = loginContext.state.accountDetails.newUser;
              // console.log('newUser status ',newUser)
              if (newUser) {
                history.push('/account');
              } else {
                history.push('/booking-list')
              }
            } else {
              setLoader(false);
              setPasswordInputClass('password-input-error');
              setToastMessage('Please enter the correct password ');
              setShowToast('block');
              setTimeout(() => {
                setShowToast('none');
              }, 2000);
            }
          }
        },
        (err) => {
          setToastMessage('Something went wrong');
          setShowToast('block');
          setTimeout(() => {
            setShowToast('none');
            setLoader(false);
          }, 6000);
        },
      )
      .catch((err) => {
        setToastMessage('Someting went wrong ! please try again');
        setShowToast('block');
        setTimeout(() => {
          setShowToast('none');
          setLoader(false);
        }, 6000);
      });
  };
  const passwordNextButtonClick = () => {
    setLoader(true);
    onClick();
  };
  const overlayClicked = (e) => {
    if (e.target.className === 'password-overlay') {
      setShowPasswordReset(false);
    } else {
      return;
    }
  };
  const passwordEyeClick = () => {
    if (password === '') {
      return;
    }
    if (passwordEyeStateVal === 'text') {
      setPasswordEyeStateVal('password');
    } else {
      setPasswordEyeStateVal('text');
    }
  };
  const passwordFocus = () => {
    setPasswordInputClass('input-green');
    setIOSbtnNormal('nextBtn-np-ios');
    setIOSbtnEnabled('nextBtn-np-enabled-ios');
  };

  const passwordBlur = () => {
    setPasswordInputClass('password-input');
    setIOSbtnNormal('');
    setIOSbtnEnabled('');
  };
  return (
    <>
      <div className="new-purchase-main-container">
        {/* <LogoAndCopyright /> */}
        <div className="right-container">
          <Link to="/phoneNumber">
            <BackArrow />
          </Link>
          <div className="vertical-center">
            <div className="password-container">
              {/* <Modal
        open={open}
        onClose={onClose}
        isShowNextBtn
        isValidBtn={passwordValid}
        onClick={passwordValid ? onClick : () => { }}
        onBackClick={onBack}
        modalId='passwordModal'
      > */}
              <Label className="password_text" text={'Enter password to login'} />
              <div className="password-subtext">{'Verify password to login to your account'}</div>
              <button
                className="unable-to-login-text"
                onClick={() => {
                  setShowPasswordReset(true);
                }}
              >
                {'Unable to Login?'}
              </button>
              {/* <div className="unable-to-login-cta" onClick={onUnableToLogin}>{unableToLogin.title}</div> */}
              <div className="space-40"></div>
              <FloatingInput
                type={passwordEyeStateVal}
                labelName={'Password'}
                inputValue={password}
                extraCss="space-letters"
                onChange={passwordChange}
                // placeholder="Password"
                className={passwordInputClass}
                onFocus={passwordFocus}
                onBlur={passwordBlur}
              />
              <img
                src={
                  passwordEyeStateVal === 'text' ? PasswordEyeShow : PasswordEye
                }
                style={
                  passwordEyeStateVal === 'text'
                    ? { opacity: '0.5' }
                    : { opacity: 1 }
                }
                className={
                  passwordEyeStateVal === 'text'
                    ? 'password-eye'
                    : 'password-eye2'
                }
                onClick={passwordEyeClick}
                alt="text"
              />
              <button
                className="unable-to-login-text-mweb"
                onClick={() => {
                  setShowPasswordReset(true);
                }}
              >
                {'Unable to Login?'}
              </button>
              {loader ? (
                <button
                  className={`nextBtn-np ${iOSbtnNormal}`}
                  onClick={passwordNextButtonClick}
                >
                  <div className="loader-container-np">
                    <LoaderLight
                      loaderData={loaderData}
                      loaderStyle="loader-light-np"
                    />
                  </div>{' '}
                </button>
              ) : (
                <button
                  className={
                    passwordValid
                      ? `nextBtn-np-enabled ${iOSbtnEnabled}`
                      : `nextBtn-np ${iOSbtnNormal} `
                  }
                  onClick={passwordNextButtonClick}
                >
                  Next
                </button>
              )}

              <div className="flex-the-toast">
                <div style={{ display: showToast }} className="custom-toast">
                  {toastMessage}
                </div>
              </div>
              {/* </Modal> */}
            </div>
          </div>
          {showPasswordReset && (
            <div
              className="password-reset-overlay"
              onClick={(e) => overlayClicked(e)}
            >
              <div className="password-overlay" />
              <div
                className="password-modal"
                onClick={(e) => overlayClicked(e)}
              >
                <div className="password_text_2">{'Unable to Login?'}</div>
                <div className="password-subtext password-modal-content">
                  {'Get a link to reset your password at your email ID registered with us. In case of further assistance, Please contact'}{' '}
                  <a href="mailto:support@olaelectric.com">
                    support@olaelectric.com
                  </a>
                </div>
                <button
                  disabled={sendingResetLink}
                  style={{ fontSize: '16px' }}
                  className="reset-btn password-reset-button reset-link-button"
                  onClick={callSendResetPasswordLink}
                >
                  {sendingResetLink ? (
                    <div>
                      <LoaderLight
                        loaderData={loaderData}
                        loaderStyle="loader-light-np"
                      />
                    </div>
                  ) : (
                    'Get Reset Link'
                  )}
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default Password;
